module.exports = __webpack_public_path__ + "friend9.png?3389dde7c269032f354492fa34a40769";


//////////////////
// WEBPACK FOOTER
// ./static/assets/friend9.png
// module id = 482
// module chunks = 0